const BannerNews = {
    init() {
        const bannerNews = $('.js-banner-news');

        if (!!bannerNews.length) {
            const bannerClose = bannerNews.find('.js-banner-news__close');
            const bannerIdentifier = bannerNews.data('identifier');
            const bannerCookie = Cookies.get(`banner-${bannerIdentifier}`);

            if (bannerCookie) {
                return;
            }
            bannerNews.addClass('enabled');
            bannerClose.on('click', () => {
                bannerNews.removeClass('enabled');
                Cookies.set(`banner-${bannerIdentifier}`, 'disabled', { expires: 365 });
            });
        }
    },
};

export default BannerNews;
